import { render, staticRenderFns } from "./prioritization-calculation-list.vue?vue&type=template&id=2326e7aa&"
import script from "./prioritization-calculation-list.vue?vue&type=script&lang=js&"
export * from "./prioritization-calculation-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports